import {Component, Inject, Input, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ReportComponent} from './report/report.component';
import {ConfService} from '../conf.service';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {ListenerService} from '../listener.service';
import {TestCaseData, TestCaseNameInputDialog} from '../testcase/testcase.component';
import {TestcaseComponent} from '../testcase/testcase.component';
import {MatDialogRef, MatTabGroup} from '@angular/material';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {ActivatedRoute, Router} from '@angular/router';
import {ConnecttocrudService} from '../connecttocrud.service';
import {KongService} from '../kong.service';
import {DialogComponent} from '../shared/dialog/dialog.component';
import {AppComponent} from '../app.component';
import {Observable} from 'rxjs';
import {ICategory} from '../crudapi/crudapi.component';
import {FormControl} from '@angular/forms';
import {HeadersComponent} from '../devex/headers/headers.component';
import {EntityVersionChangeConfirmationComponent} from '../edit-entity/edit-entity.component';
import {environment} from 'src/environments/environment';
import {TestsuiteListenerService} from '../testsuite-listener.service';
import {TourStep} from 'ngx-guided-tour/lib/guided-tour.constants';
import {Orientation} from 'ngx-guided-tour';
import {WebsocketService} from '../websocket.service';
import {TestReportComponent} from './test-report/test-report.component';
import {NgxXml2jsonService} from 'ngx-xml2json';
import * as converter from 'xml-js';
import * as CryptoJS from 'crypto-js';
import {AccountInfoService} from '../user/account-info.service';
import {AuditLogService} from '../audit-log.service';
import {TestcaseInteractionService} from '../services/testcase-interaction.service';

const incr = 5;

export interface TestSuiteData {
    testSuitePayload;
    testSuiteResponse;
}

export interface TestcaseDeleteData {
    name;
}

@Component({
    selector: 'app-testsuite',
    templateUrl: './testsuite.component.html',
    styleUrls: ['./testsuite.component.scss']
})

export class TestsuiteComponent implements OnInit, AfterViewInit {

    @ViewChild('testsuite') testsuite: MatTabGroup;
    selectedTab = 0;
    options1 = new JsonEditorOptions();
    scope = [{'displayName': 'Public', 'value': 'public'},
        {'displayName': 'Private', 'value': 'private'}];

    passphrase = environment.cipheringPhrase;
    iterationCount = 1000;
    keySize = 128 / 32;

    constructor(public httpClient: HttpClient,
                public dialog: MatDialog,
                private confPost: ConfService,
                public platform: LeftpanelComponent,
                public accountInfoService: AccountInfoService,
                private auditLog: AuditLogService,
                private leftPanelDataListener: ListenerService,
                private _route: ActivatedRoute,
                private _service: ConnecttocrudService,
                private router: Router,
                private kongService: KongService,
                private appComp: AppComponent,
                private websocketService: WebsocketService,
                private testSuiteListenerInstance: TestsuiteListenerService,
                private ngxXml2jsonService: NgxXml2jsonService,
                private testcaseInteractionService: TestcaseInteractionService) {
        this.options1.mode = 'code';
        this.options1.modes = ['code', 'text', 'tree', 'view'];
        this.options1.schema = '';
        this.options1.statusBar = false;
        this.options1.onChange = () => console.log( /*this.editor.get()*/);
    }

    testcase = [];
    devExURL: any;
    showPathParameters;
    httpUrl = '';
    executorMethods = [
        {'name': 'GET'},
        {'name': 'POST'},
        {'name': 'PUT'},
        {'name': 'PATCH'},
        {'name': 'DELETE'}
    ];
    executorTypes = [
        {value: 'TESTSUITE', displayName: 'Create Manually'},
        {value: 'EXTERNALTESTSUITE', displayName: 'Import from SCM'}
    ];
    executorType = 'TESTSUITE';
    authModel = [];
    headersData = [];
    prerequisites = [];
    requestBody = {};
    requestBodySelected = '';
    parameterData = [];
    pathParameter = [];
    formData = [];
    responseData = [];
    errorMessage = '';
    responseError = '';
    pathParameterSegregator: any;
    pathParameterStopper: any;
    pathParameterValue: any;
    httpOperation = 'GET';
    testCasesPayload = [];
    prestepsPayload = [];
    teardownPayload = [];
    testSuitePayload = {};
    previousSavedData: any;
    isToggleExpanded = false;
    find: any;
    Index: any;
    @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
    @Input() partnerId = localStorage.getItem('partner');
    @Input() accountId = localStorage.getItem('account');
    @ViewChild(HeadersComponent) headerChild: HeadersComponent;
    testSuiteResponse;
    Blocks;
    BlockList = {
        '1': 0,
        '2': 25,
        '3': 50,
        '4': 75,
        '5': 100
    };
    progress = 0;
    progressMessage;
    destroy: any;
    gatewayFullUrl;
    partnerKey = localStorage.getItem('partnerKey');
    save;
    @Input() executor_name;
    @Input() executor_version;
    @Input() disableButtons = false;
    selectedVersion;
    selectedExecutor = 'POST';
    executorCategory: string;
    myControl = new FormControl();
    filteredOptions: Observable<ICategory[]>;
    executor_display_name;
    description;
    scopeSelected = 'public';
    editFlag = false;

    logVisible = false;
    refreshLogCount = 0;
    logTimeStamp: any;
    logComponentRefresh = false;
    apiDeploymentLogs = [];
    currentMessage: any;
    apiType = 'TESTSUITE';

    isAPIAlreadyPresent: boolean;
    isAPIAlreadyPresentCheckCompleted = false;
    previouslyCheckedName: any;
    previouslyCheckedVersion: any;
    editable_executor_name: any;
    editable_executor_version: any;

    orig_executor: any;
    orig_executor_name: any;
    orig_executor_version: any;

    loading1 = false;
    testLoading = false;
    fromHistory = false;
    action: any;
    connection: any;
    showDialogOnNonWebsocketConnection: any;

    externalTestsuiteConfigs = {
        repositoryUrl: '',
        branchSpecifier: '',
        executionCommands: ''
    };


    externalTestsuiteObj = {
        project: {
            actions: {},
            description: {},
            keepDependencies: {
                _text: 'false'
            },
            properties: {
                'com.synopsys.arc.jenkinsci.plugins.jobrestrictions.jobs.JobRestrictionProperty': {
                    _attributes: {
                        plugin: 'job-restrictions@0.8'
                    }
                },
                'hudson.security.AuthorizationMatrixProperty': {
                    'inheritanceStrategy': {
                        '_attributes': {
                            'class': 'org.jenkinsci.plugins.matrixauth.inheritance.NonInheritingStrategy'
                        }
                    },
                    'permission': [
                        {
                            '_text': 'USER:com.cloudbees.plugins.credentials.CredentialsProvider.Create:apiplatform'
                        },
                        {
                            '_text': 'USER:com.cloudbees.plugins.credentials.CredentialsProvider.Delete:apiplatform'
                        },
                        {
                            '_text': 'USER:com.cloudbees.plugins.credentials.CredentialsProvider.ManageDomains:apiplatform'
                        },
                        {
                            '_text': 'USER:com.cloudbees.plugins.credentials.CredentialsProvider.Update:apiplatform'
                        },
                        {
                            '_text': 'USER:com.cloudbees.plugins.credentials.CredentialsProvider.View:apiplatform'
                        },
                        {
                            '_text': 'USER:hudson.model.Item.Build:apiplatform'
                        },
                        {
                            '_text': 'USER:hudson.model.Item.Cancel:apiplatform'
                        },
                        {
                            '_text': 'USER:hudson.model.Item.Configure:apiplatform'
                        },
                        {
                            '_text': 'USER:hudson.model.Item.Delete:apiplatform'
                        },
                        {
                            '_text': 'USER:hudson.model.Item.Discover:apiplatform'
                        },
                        {
                            '_text': 'USER:hudson.model.Item.Move:apiplatform'
                        },
                        {
                            '_text': 'USER:hudson.model.Item.Read:apiplatform'
                        },
                        {
                            '_text': 'USER:hudson.model.Item.Workspace:apiplatform'
                        },
                        {
                            '_text': 'USER:hudson.model.Run.Delete:apiplatform'
                        },
                        {
                            '_text': 'USER:hudson.model.Run.Update:apiplatform'
                        },
                        {
                            '_text': 'USER:hudson.scm.SCM.Tag:apiplatform'
                        }
                    ]
                }
            },
            scm: {
                _attributes: {
                    class: 'hudson.plugins.git.GitSCM',
                    plugin: 'git@4.8.3'
                },
                configVersion: {
                    _text: '2'
                },
                userRemoteConfigs: {
                    'hudson.plugins.git.UserRemoteConfig': {
                        url: {
                            _text: 'https://github.com/pluralsight/intro-to-pytest.git'
                        }
                    }
                },
                branches: {
                    'hudson.plugins.git.BranchSpec': {
                        'name': {
                            '_text': '*/master'
                        }
                    }
                },
                doGenerateSubmoduleConfigurations: {
                    _text: 'false'
                },
                submoduleCfg: {
                    _attributes: {
                        class: 'empty-list'
                    }
                },
                extensions: {}
            },
            assignedNode: {
                _text: 'jenkins-slave1'
            },
            canRoam: {
                _text: 'false'
            },
            disabled: {
                _text: 'false'
            },
            blockBuildWhenDownstreamBuilding: {
                _text: 'false'
            },
            blockBuildWhenUpstreamBuilding: {
                _text: 'false'
            },
            triggers: {},
            concurrentBuild: {
                _text: 'false'
            },
            builders: {
                'hudson.tasks.Shell': {
                    command: {
                        _text: 'export PATH=$PATH:/home/jenkins/.local/bin ; pip install -r requirements.txt ; pytest'
                    },
                    configuredLocalRules: {}
                },
            },
            publishers: {},
            buildWrappers: {}
        }
    };

    async ngOnChanges() {
        this.appComp.currentPageTitle = 'TESTSUITE';
    }
    ngAfterViewInit() {
    }

    onDeployClick() {
        if (this.executor_name && this.selectedVersion && this.selectedExecutor && this.executorCategory &&
            this.executor_name !== '' && this.selectedVersion !== '' && this.executorCategory !== '') {
            this.testcaseInteractionService.executeApi('deploy');
        } else {
            this.platform.openSnackBar('Please enter all the required fields.', 'Error', {
                duration: 10000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    onSaveClick() {
        this.testcaseInteractionService.executeApi('save');
    }

    onTestClick() {
        this.testcaseInteractionService.executeApi('test');
    }

    onApiExecutionComplete(event: string) {
        if (event === 'deploy') {
            this.validateData();
        } else if (event === 'save') {
            this.saveAPI();
        } else if (event === 'test') {
            this.runTestSuite();
        }
    }

    tabChanged(event) {
        this.selectedTab = event.index;
    }

    closeNonWSDialogBox() {
        if (this.showDialogOnNonWebsocketConnection) {
            this.showDialogOnNonWebsocketConnection.close();
        }
        if (!this.websocketService.isOpen()) {
            this.logVisible = true;
            this.refreshLogCount++;
        }
    }

    getTestSuiteTourSteps(): Array<TourStep> {

        let steps: TourStep[] = [];
        steps.push({
            title: this.platform.getProperty('GT_TEST_SUITE_INTRO_TITLE'),
            content: this.platform.getProperty('GT_TEST_SUITE_INTRO_CONTENT'),
        }, {
            title: this.platform.getProperty('EXECUTOR_NAME_TITLE'),
            selector: '.tour-create-executor-name',
            content: this.platform.getProperty('EXECUTOR_NAME_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('EXECUTOR_VERSION_TITLE'),
            selector: '.tour-create-executor-version',
            content: this.platform.getProperty('EXECUTOR_VERSION_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('EXECUTOR_METHOD_TYPE_TITLE'),
            selector: '.tour-create-executor-method-type',
            content: this.platform.getProperty('EXECUTOR_METHOD_TYPE_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('EXECUTOR_CATEGORY_TITLE'),
            selector: '.tour-create-executor-category',
            content: this.platform.getProperty('EXECUTOR_CATEGORY_CONTENT'),
            orientation: Orientation.Bottom
        });

        steps.push({
            title: this.platform.getProperty('GT_TEST_SUITE_SETUP_TAB_TITLE'),
            selector: '.tour-create-testsuite-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(1)',
            content: this.platform.getProperty('GT_TEST_SUITE_SETUP_TAB_CONTENT'),
            orientation: Orientation.Bottom,
            action: (() => {
                this.selectedTab = 0;
            })
        });

        steps = steps.concat(this.getTestSetupTourSteps());

        steps.push({
            title: this.platform.getProperty('GT_TEST_SUITE_TESTCASES_TAB_TITLE'),
            selector: '.tour-create-testsuite-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(2)',
            content: this.platform.getProperty('GT_TEST_SUITE_TESTCASES_TAB_CONTENT'),
            orientation: Orientation.Bottom,
            action: (() => {
                this.selectedTab = 1;
            })
        });

        steps = steps.concat(this.getTestCasesTourSteps());

        steps.push({
            title: this.platform.getProperty('GT_TEST_SUITE_TEARDOWN_TAB_TITLE'),
            selector: '.tour-create-testsuite-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(3)',
            content: this.platform.getProperty('GT_TEST_SUITE_TEARDOWN_TAB_CONTENT'),
            orientation: Orientation.Bottom,
            action: (() => {
                this.selectedTab = 2;
            })
        });

        steps = steps.concat(this.getTearDownTourSteps());

        steps.push({
            title: this.platform.getProperty('GT_TEST_SUITE_SAVE_API_TITLE'),
            selector: '.tour-create-executor-save-api',
            content: this.platform.getProperty('GT_TEST_SUITE_SAVE_API_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.platform.getProperty('GT_TEST_SUITE_TEST_TITLE'),
            selector: '.tour-create-executor-tester',
            content: this.platform.getProperty('GT_TEST_SUITE_TEST_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.platform.getProperty('GT_TEST_SUITE_DEPLOY_API_TITLE'),
            selector: '.tour-create-executor-create-api',
            content: this.platform.getProperty('GT_TEST_SUITE_DEPLOY_API_CONTENT'),
            orientation: Orientation.Left
        });

        return steps;
    }

    getTestSetupTourSteps(): Array<TourStep> {

        const steps: TourStep[] = [];
        steps.push({
            title: this.platform.getProperty('GT_TEST_SUITE_SETUP_ADD_A_STEP_TITLE'),
            selector: '.tour-test-suite-executor-add-a-step',
            content: this.platform.getProperty('GT_TEST_SUITE_SETUP_ADD_A_STEP_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.platform.getProperty('GT_TEST_SUITE_SETUP_DELETE_STEP_TITLE'),
            selector: '.tour-test-suite-executor-delete-a-step',
            content: this.platform.getProperty('GT_TEST_SUITE_SETUP_DELETE_STEP_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.platform.getProperty('GT_TEST_SUITE_SETUP_SAVE_STEPS_TITLE'),
            selector: '.tour-test-suite-executor-save-steps',
            content: this.platform.getProperty('GT_TEST_SUITE_SETUP_SAVE_STEPS_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.platform.getProperty('GT_TEST_SUITE_SETUP_SEARCH_STEPS_TITLE'),
            selector: '.tour-test-suite-executor-search-a-step',
            content: this.platform.getProperty('GT_TEST_SUITE_SETUP_SEARCH_STEPS_CONTENT'),
            orientation: Orientation.Left
        });

        return steps;
    }

    getTestCasesTourSteps(): Array<TourStep> {

        const steps: TourStep[] = [];
        steps.push({
            title: this.platform.getProperty('GT_TEST_SUITE_TESTCASE_ADD_A_STEP_TITLE'),
            selector: '.tour-test-suite-testcase-add',
            content: this.platform.getProperty('GT_TEST_SUITE_TESTCASE_ADD_A_STEP_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.platform.getProperty('GT_TEST_SUITE_TESTCASE_DELETE_STEP_TITLE'),
            selector: '.tour-test-suite-tescase-delete',
            content: this.platform.getProperty('GT_TEST_SUITE_TESTCASE_DELETE_STEP_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.platform.getProperty('GT_TEST_SUITE_TESTCASE_SEARCH_STEPS_TITLE'),
            selector: '.tour-test-suite-testcase-search',
            content: this.platform.getProperty('GT_TEST_SUITE_TESTCASE_SEARCH_STEPS_CONTENT'),
            orientation: Orientation.Left
        });

        return steps;
    }

    getTearDownTourSteps(): Array<TourStep> {

        const steps: TourStep[] = [];
        steps.push({
            title: this.platform.getProperty('GT_TEST_SUITE_TEARDOWN_ADD_A_STEP_TITLE'),
            selector: '.tour-test-suite-executor-add-a-step',
            content: this.platform.getProperty('GT_TEST_SUITE_TEARDOWN_ADD_A_STEP_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.platform.getProperty('GT_TEST_SUITE_TEARDOWN_DELETE_STEP_TITLE'),
            selector: '.tour-test-suite-executor-delete-a-step',
            content: this.platform.getProperty('GT_TEST_SUITE_TEARDOWN_DELETE_STEP_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.platform.getProperty('GT_TEST_SUITE_TEARDOWN_SAVE_STEPS_TITLE'),
            selector: '.tour-test-suite-executor-save-steps',
            content: this.platform.getProperty('GT_TEST_SUITE_TEARDOWN_SAVE_STEPS_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.platform.getProperty('GT_TEST_SUITE_TEARDOWN_SEARCH_STEPS_TITLE'),
            selector: '.tour-test-suite-executor-search-a-step',
            content: this.platform.getProperty('GT_TEST_SUITE_TEARDOWN_SEARCH_STEPS_CONTENT'),
            orientation: Orientation.Left
        });

        return steps;
    }

    closeLogPanel() {
        this.logVisible = false;
        if (this.editFlag === false) {
            this.confPost.getAPIExecutorForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'), this.partnerKey, this.executor_name, this.selectedVersion).subscribe(response => {
                if (response !== null && response !== undefined) {
                    this.router.navigateByUrl('/testsuite?partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&entity=' + this.executor_name + '&version=' + this.selectedVersion);
                }
            });
        }
    }

    hasViewPagePermissions() {
        if (this.editFlag === true) {
            if (this.fromHistory === true) {
                return (this.platform.hasPermissions(['EDIT_HISTORY', 'EDIT_TEST_SUITE_API', 'edit:' + this.partnerId + '=>' + this.accountId + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]));
            } else {
                return this.platform.hasPermissions(['EDIT_TEST_SUITE_API', 'edit:' + this.partnerId + '=>' + this.accountId + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
            }
        } else {
            if (this.fromHistory === true) {
                return (this.platform.hasPermissions(['EDIT_HISTORY', 'CREATE_TEST_SUITE_API']));
            } else {
                return this.platform.hasPlatformPermission('CREATE_TEST_SUITE_API');
            }
        }

    }

    hasTestPermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['TEST_TEST_SUITE_API', 'test:' + this.partnerId + '=>' + this.accountId + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
        } else {
            return this.platform.hasPlatformPermission('TEST_TEST_SUITE_API');
        }
    }

    hasSavePermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['SAVE_TEST_SUITE_API', 'save:' + this.partnerId + '=>' + this.accountId + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
        } else {
            return this.platform.hasPlatformPermission('SAVE_TEST_SUITE_API');
        }
    }

    async ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        this.appComp.currentPageTitle = 'TESTSUITE';
        this._route.queryParams.subscribe(async params => {
                this.fromHistory = false;
                this.editFlag = false;
                if (params.timestamp && params.timestamp !== '') {
                    this.fromHistory = true;
                    this.confPost.getData('services', 'services', 'v1', 'apiHistory', 'partner=' + this.partnerId + '&account=' + this.accountId + '&at=' + params.timestamp).subscribe(response => {
                        if (response && response[0] && response[0]['executor']) {
                            const executor = response[0]['executor'];
                            this.executor_name = response[0]['executor_name'];
                            this.selectedVersion = response[0]['executor_version'];
                            this.selectedExecutor = executor['executor_method_type'];
                            this.executorCategory = executor['executor_category'];
                            this.executor_display_name = executor['executor_display_name'];
                            this.description = executor['description'];
                            this.scopeSelected = executor['executoscopeOfAccessr_scope'];
                            this.prestepsPayload = executor['preSteps'];
                            this.testCasesPayload = executor['testCases'];
                            this.teardownPayload = executor['tearDownSteps'];
                            if (response[0]['action'] === 'CREATE') {
                                this.editFlag = false;
                            } else {
                                this.editFlag = true;
                            }
                        }
                    });
                } else if ((params.entity && params.version) || this.executor_name && this.executor_version) {
                    let partner;
                    let account;
                    let entity;
                    let version;
                    if ((params.entity && params.version)) {
                        partner = params.partner;
                        account = params.account;
                        entity = params.entity;
                        version = params.version;
                    } else if (this.executor_name && this.executor_version) {
                        partner = this.partnerId;
                        account = this.accountId;
                        entity = this.executor_name;
                        version = this.executor_version;
                    }
                    this.confPost.getApiExecutorByPartnerAccountEntityVersion(partner, account, entity, version).subscribe(async response => {
                        if (response) {
                            const executor = response['executors'][0];
                            this.editable_executor_name = response['executor_name'];
                            this.editable_executor_version = response['executor_version'];
                            this.orig_executor_name = response['executor_name'];
                            this.orig_executor_version = response['executor_version'];
                            this.executor_name = response['executor_name'];
                            this.selectedVersion = response['executor_version'];
                            this.selectedExecutor = response['executor_method_type'];
                            this.executorCategory = response['executor_category'];
                            this.executor_display_name = response['executor_display_name'];
                            this.description = response['description'];
                            this.scopeSelected = response['scopeOfAccess'];
                            this.prestepsPayload = executor ? executor['preSteps'] : null;
                            this.testCasesPayload = executor ? executor['testCases'] : null;
                            this.teardownPayload = executor ? executor['tearDownSteps'] : null;
                            this.headersData = response['headers'] ? response['headers'] : [];
                            this.orig_executor = response;

                            this.executorType = response['executor_type'];

                            if (this.executorType === 'EXTERNALTESTSUITE') {
                                await this.platform.decryptAttribute(response['workflow_credentials']['shash'], response['workflow_credentials']['ralam'], this.passphrase, response['source'], this.keySize, this.iterationCount).then(response1 => {
                                    // configData[key] = response1;
                                    let resp: any;
                                    resp = response1;
                                    const result1 = converter.xml2json(resp, {compact: true, spaces: 2});

                                    this.externalTestsuiteObj = JSON.parse(result1);
                                    this.updateValuesFromXML();
                                });
                            }

                            this.editFlag = true;
                        }
                    });
                }
            }
        );
        this.platform.setGuideTourSteps(this.getTestSuiteTourSteps());
    }

    getBackgroundStyle(val) {
        if (val === 'GET') {
            return 'get-method';
        } else if (val === 'PUT') {
            return 'put-method';
        } else if (val === 'POST') {
            return 'post-method';
        } else if (val === 'DELETE') {
            return 'delete-method';
        } else {
            return 'get-method';
        }
    }


    toggleExecutor(ev) {
        this.isToggleExpanded = !this.isToggleExpanded;
        $('.executor-definition').slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
    }

    toggleExecutor1(ev) {
        if (ev === 'DELETE') {
            if (this.isToggleExpanded === true) {
                this.isToggleExpanded = false;
                $('.executor-definition').slideToggle();
                $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
            }
        } else {
            if (this.isToggleExpanded === false) {
                this.isToggleExpanded = true;
                $('.executor-definition').slideToggle();
                $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
            }
        }
    }


    CheckForExistingEntityOrExecutor() {
        return new Promise((resolve, reject) => {
            Promise.resolve(this.platform.CheckForExistingEntityOrExecutor(this.executor_name, this.selectedVersion)).then(response => {
                this.isAPIAlreadyPresent = false;
                this.isAPIAlreadyPresentCheckCompleted = false;
                this.previouslyCheckedName = this.executor_name;
                this.previouslyCheckedVersion = this.selectedVersion;
                resolve('success');
            }, error => {
                if (error && error.status) {
                    if (error.status === 'already exists') {
                        this.isAPIAlreadyPresent = true;
                        this.isAPIAlreadyPresentCheckCompleted = false;
                        this.previouslyCheckedName = this.executor_name;
                        this.previouslyCheckedVersion = this.selectedVersion;
                        resolve('failed');
                        this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    } else if (error.status === 'failed') {
                        this.isAPIAlreadyPresent = true;
                        this.isAPIAlreadyPresentCheckCompleted = false;
                        this.previouslyCheckedName = this.executor_name;
                        this.previouslyCheckedVersion = this.selectedVersion;
                        resolve('failed');
                        this.platform.openSnackBar('Error occurred while checking your existing API information. Please try again after sometime.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                }
            });
        });
    }

    checkForExistingEntityAndExecutor() {
        return new Promise(async (resolve, reject) => {
            if (this.executor_name !== null && this.executor_name !== undefined && this.executor_name !== '' && this.selectedVersion !== null && this.selectedVersion !== undefined && this.selectedVersion !== '') {
                if (this.isAPIAlreadyPresentCheckCompleted === false) {
                    if (this.previouslyCheckedName !== undefined && this.previouslyCheckedName !== null && this.previouslyCheckedVersion !== undefined && this.previouslyCheckedVersion !== null) {
                        if (this.editFlag === true) {
                            if (this.previouslyCheckedName !== this.executor_name || this.previouslyCheckedVersion !== this.selectedVersion) {
                                this.isAPIAlreadyPresentCheckCompleted = true;
                                await this.CheckForExistingEntityOrExecutor();
                                resolve('success');
                            } else {
                                resolve('success');
                            }
                        } else {
                            if (this.previouslyCheckedName !== this.executor_name || this.previouslyCheckedVersion !== this.selectedVersion) {
                                this.isAPIAlreadyPresentCheckCompleted = true;
                                await this.CheckForExistingEntityOrExecutor();
                                resolve('success');
                            } else {
                                resolve('success');
                            }
                        }
                    } else {
                        this.isAPIAlreadyPresentCheckCompleted = true;
                        await this.CheckForExistingEntityOrExecutor();
                        resolve('success');
                    }
                } else {
                    resolve('success');
                }
            }
        });
    }

    checkForExistingEntityAndExecutorFromFocusOut() {
        setTimeout(() => {
            this.checkForExistingEntityAndExecutor();
        }, 2000);
    }

    parameterDataCheck(event: any) {
        // /: calculation
        if (this.devExURL !== event.target.value) {
            this.devExURL = event.target.value;
            this.pathParameterSegregator = this.devExURL.split('/:');
            for (let i = 1; i < this.pathParameterSegregator.length; i++) {
                this.pathParameterStopper = this.pathParameterSegregator[i].split('/');
                this.pathParameterSegregator[i] = this.pathParameterStopper[0];
            }
            // {} for calculation
            let temp2 = this.devExURL.split('/');
            // /: append
            this.pathParameter = [];
            for (let i = 1; i < this.pathParameterSegregator.length; i++) {
                this.pathParameterValue = this.pathParameterSegregator[i];
                this.find = true;
                for (let j = 0; j < this.pathParameter.length; j++) {
                    if (this.pathParameterSegregator[i] === this.pathParameter[j]['key']) {
                        this.find = false;
                    }
                }
                if (this.find === true) {
                    this.pathParameter.push({'key': this.pathParameterValue, 'value': '', 'description': ''});
                }
            }
            // {} append
            for (let i = 2; i < temp2.length; i++) {
                const init = temp2[i].indexOf('{');
                const fin = temp2[i].indexOf('}');
                if ((!(this.pathParameter.some(e => e.key === temp2[i].substr(init + 1, fin - init - 1))) && temp2[i].substr(init + 1, fin - init - 1) !== '') && init !== -1 && fin !== -1) {
                    this.pathParameter.push({
                        'key': temp2[i].substr(init + 1, fin - init - 1),
                        'value': '',
                        'description': ''
                    });
                }
            }
            // confirm to show the path parameter area.
            if (this.pathParameter.length !== 0) {
                this.showPathParameters = true;
            } else {
                this.showPathParameters = false;
            }
        }
    }

    checkQueryParams(event) {
        const tempUrl = event.target.value;
        const seperator = tempUrl.split('/');
        let query: any;
        let finalquery: any;
        if (seperator.length > 0) {
            query = seperator[seperator.length - 1].split('?');
            if (query.length > 1) {
                finalquery = query[query.length - 1].split('&');
                if (finalquery) {
                    for (let i = 0; i < finalquery.length; i++) {
                        let temp = finalquery[i].split('=');
                        let flag = false;
                        for (let j = 0; j < this.parameterData.length; j++) {
                            if (temp[0].includes(this.parameterData[j]['key']) || this.parameterData[j]['key'].includes(temp[0]) || this.parameterData[j]['key'] === temp[0]) {
                                flag = true;
                                if (temp.length > 1) {
                                    this.parameterData[j]['key'] = temp[0];
                                    this.parameterData[j]['value'] = temp[1];
                                } else {
                                    this.parameterData[j]['key'] = temp[0];
                                    this.parameterData[j]['value'] = '';
                                }
                            }
                        }
                        if (flag === false) {
                            if (temp.length > 1) {
                                this.parameterData.push({key: temp[0], value: temp[1], description: ''});
                            } else {
                                this.parameterData.push({key: temp[0], value: '', description: ''});
                            }
                        }
                    }
                }
            }
        }
    }

    prestepsCompleted(prestepsPayload) {
        this.prestepsPayload = prestepsPayload;
    }

    teardownCompleted(teardownPayload) {
        this.teardownPayload = teardownPayload;
    }

    testCasesCompleted(testCasesPayload) {
        this.testCasesPayload = testCasesPayload;
    }

    displaySnackBarWithWS(type, duration, msg) {
        if (!this.websocketService.isOpen()) {
            this.platform.openSnackBar(msg, type, {
                duration: duration,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    listenAPICreation(timestamp, apiName, apiVersion, action) {
        if (this.websocketService.isOpen()) {
            this.websocketService.listenAPICreation(localStorage.getItem('partner'), localStorage.getItem('account'), apiName, apiVersion, localStorage.getItem('sessionID'), timestamp, action).subscribe(data => {
                if (data) {
                    this.currentMessage = JSON.parse(data.body);
                }
            });
        }
    }

    async validateData() {

        this.logVisible = false;
        if (this.websocketService.isOpen()) {
            this.connection = true;
            // this.logVisible = true;
        } else {
            this.connection = false;
        }


        const timeStamp = Date.now();

        this.logTimeStamp = timeStamp;
        this.logComponentRefresh = true;

        if (this.editFlag === false) {
            this.action = 'deploy';
        } else {
            this.action = 'redeploy';

        }

        this.loading1 = true;
        if (this.connection === false) {
            this.showDialogOnNonWebsocketConnection = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
                data: {
                    message: 'API deployment is under progress. Please don\'t close the window'
                }
            });
        }

        this.listenAPICreation(timeStamp, this.executor_name, this.selectedVersion, this.action);
        const clickMessage = this.editFlag === true ? 'testsuite_edit_redeploy_clicked' : 'testsuite_create_deploy_clicked';


        if (this.executor_name && this.selectedVersion && this.selectedExecutor && this.executorCategory &&
            this.executor_name !== '' && this.selectedVersion !== '' && this.executorCategory !== '') {

            Promise.resolve(this.platform.specialCharAndPasteValidationForEntityNameAndVersion(this.executor_name, this.selectedVersion, timeStamp, this.action)).then(async response => {
                if (response) {
                    if (this.editFlag === false) {
                        this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REQUIREMENTS', {
                            info: 'Checking for API existence',
                            type: 'initial',
                            icon: 'fa fa-newspaper-o'
                        }, timeStamp, this.action);
                        await this.CheckForExistingEntityOrExecutor();
                        if (this.isAPIAlreadyPresent === false) {
                            this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REQUIREMENTS', {
                                info: 'Checking for API existence',
                                type: 'success',
                                icon: 'fa fa-newspaper-o'
                            }, timeStamp, this.action);
                            if (this.executorType === 'TESTSUITE') {
                                this.deployTestSuite(timeStamp);
                            } else if (this.executorType === 'EXTERNALTESTSUITE') {
                                this.deployExternalTestSuite(timeStamp);
                            }
                        } else {
                            this.loading1 = false;
                            if (this.showDialogOnNonWebsocketConnection) {
                                this.showDialogOnNonWebsocketConnection.close();
                            }
                            // this.displaySnackBarWithWS('Error', 5000, 'An API with the provided name and version already exists.');
                            // await this.platform.delay(1500);
                            this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REQUIREMENTS', {
                                info: 'Checking for API existence',
                                type: 'fatal',
                                description: 'An API with the provided name and version already exists.',
                                icon: 'fa fa-newspaper-o'
                            }, timeStamp, this.action);
                            this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                    } else {
                        if (this.orig_executor_name === this.executor_name && this.orig_executor_version === this.selectedVersion) {
                            if (this.executorCategory !== undefined && this.executorCategory !== '') {
                                if (this.executorType === 'TESTSUITE') {
                                    this.deployTestSuite(timeStamp);
                                } else if (this.executorType === 'EXTERNALTESTSUITE') {
                                    this.deployExternalTestSuite(timeStamp);
                                }
                            } else {
                                this.loading1 = false;
                                if (this.showDialogOnNonWebsocketConnection) {
                                    this.showDialogOnNonWebsocketConnection.close();
                                }
                                this.platform.openSnackBar('Please enter a valid executor category.', 'Error', {
                                    duration: 10000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                            }
                        } else {
                            const publishdata = {};
                            let message = 'Change in entity';
                            publishdata['orig_executor_name'] = this.orig_executor_name;
                            publishdata['orig_executor_version'] = this.orig_executor_version;
                            publishdata['entity'] = this.executor_name;
                            publishdata['version'] = this.selectedVersion;
                            publishdata['tableName'] = 'testsuite';
                            publishdata['origCollection'] = 'testsuite';

                            if (this.orig_executor_name !== this.executor_name) {
                                if (this.orig_executor_version !== this.selectedVersion) {
                                    message = 'Both the name and version of the entity have been changed. Hence this will create another entity : ' + this.executor_name + ' with the version: ' + this.selectedVersion + '. Do you want to continue creating a new Test Suite API ?';
                                } else {
                                    message = 'Name of the entity has been changed. Hence this will create another entity : ' + this.executor_name + ' with the version: ' + this.selectedVersion + '. Do you want to continue creating a new Test Suite API ?';
                                }
                            } else {
                                if (this.orig_executor_version !== this.selectedVersion) {
                                    message = 'Version of the entity has been changed. Hence this will create another entity : ' + this.executor_name + ' with the version: ' + this.selectedVersion + '. Do you want to continue creating a new Test Suite API ?';
                                }
                            }
                            if (this.executor_name !== '' && this.selectedVersion !== '') {
                                if (this.executorCategory !== undefined && this.executorCategory !== '') {
                                    // this.loading1 = false;
                                    publishdata['message'] = message;
                                    if (this.isAPIAlreadyPresentCheckCompleted === false) {
                                        await this.checkForExistingEntityAndExecutor();
                                    }

                                    if (this.isAPIAlreadyPresent === false) {
                                        const dialogRef = this.dialog.open(EntityVersionChangeConfirmationComponent, {
                                            width: '60%',
                                            data: publishdata
                                        });
                                        dialogRef.afterClosed().subscribe(result => {
                                            if (result) {
                                                // Create API
                                                this.loading1 = true;
                                                this.editFlag = false;
                                                if (this.executorType === 'TESTSUITE') {
                                                    this.deployTestSuite(timeStamp);
                                                } else if (this.executorType === 'EXTERNALTESTSUITE') {
                                                    this.deployExternalTestSuite(timeStamp);
                                                }
                                            }
                                        });
                                    } else {
                                        this.loading1 = false;
                                        if (this.showDialogOnNonWebsocketConnection) {
                                            this.showDialogOnNonWebsocketConnection.close();
                                        }
                                        this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                                            duration: 5000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                    }
                                } else {
                                    this.loading1 = false;
                                    if (this.showDialogOnNonWebsocketConnection) {
                                        this.showDialogOnNonWebsocketConnection.close();
                                    }
                                    this.platform.openSnackBar('Please enter a valid executor category.', 'Error', {
                                        duration: 10000,
                                        verticalPosition: 'top',
                                        horizontalPosition: 'center'
                                    });
                                }
                            } else {
                                this.loading1 = false;
                                if (this.showDialogOnNonWebsocketConnection) {
                                    this.showDialogOnNonWebsocketConnection.close();
                                }
                                this.platform.openSnackBar('Please enter a valid executor name and version.', 'Error', {
                                    duration: 10000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                            }
                        }
                    }
                } else {
                    if (this.showDialogOnNonWebsocketConnection) {
                        this.showDialogOnNonWebsocketConnection.close();
                    }
                    this.loading1 = false;
                    this.platform.openSnackBar('Please enter a valid executor name and version.', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            }, error => {});
        } else {
            this.loading1 = false;
            if (this.showDialogOnNonWebsocketConnection) {
                this.showDialogOnNonWebsocketConnection.close();
            }
            this.platform.openSnackBar('Please enter all the required fields.', 'Error', {
                duration: 10000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    async deployTestSuite(timeStamp) {

        if (this.websocketService.isOpen()) {
            this.logVisible = true;
        }
        // let action = '';
        // if (this.editFlag === true) {
        //     action = 'redeploy';
        // } else {
        //     action = 'deploy';
        // }
        //
        // this.action = action;
        const action = this.action;

        const successMessage = this.editFlag === true ? 'testsuite_edit_redeploy_success' : 'testsuite_create_deploy_success';
        const failedMessage = this.editFlag === true ? 'testsuite_edit_redeploy_failed' : 'testsuite_create_deploy_failed';
        this.loading1 = true;
        var that = this;
        this.gatewayFullUrl = 'https://' + await this.platform.getDefaultGatewayURL();
        const baseExeModel = {
            //'executor_name': this.executor_name,
            'executor_type': 'API',
            'executor_version': this.selectedVersion,
            'executor_method_type': this.httpOperation,
            'apiUrl': this.httpUrl,
            'dataroot': null,
            'queryParams': this.parameterData,
            'pathParams': this.pathParameter,
            'headers': this.headersData,
            'requestBody': await this.headerChild.getRequestBody(),
            //'executors': this.executors,
            'prerequisites': null
        };
        this.testSuitePayload['name'] = this.executor_name;
        this.testSuitePayload['description'] = this.description;
        this.testSuitePayload['baseExecutorModel'] = baseExeModel;
        this.testSuitePayload['preSteps'] = this.prestepsPayload;
        this.testSuitePayload['tearDownSteps'] = this.teardownPayload;
        this.testSuitePayload['testCases'] = this.testCasesPayload;

        const fabResult = {
            'executor_type': 'TESTSUITE',
            'executor_name': this.executor_name,
            'executor_version': this.selectedVersion,
            'executor_display_name': this.executor_display_name,
            'executor_description': this.description,
            'executor_category': this.executorCategory,
            'published': true,
            'scopeOfAccess': this.scopeSelected,
            'creationTime': Date.now(),
            'lastModifiedTime': Date.now(),
            'registeredAsIs': false,
            'executor_method_type': this.selectedExecutor,
            'queryParams': this.parameterData,
            'headers': this.headersData,
            'requestBody': this.requestBody,
            'prerequisites': this.prerequisites,
            'executors': [this.testSuitePayload],
            'partner': this.partnerId,
            'account_id': this.accountId,
            'apiUrl': this.gatewayFullUrl + '/' + this.selectedVersion + '/' + this.executor_name,
            //'apiUrl': environment.konghost + '/' + this.selectedVersion + '/' + this.partnerId + '/' + this.accountId + '/' + this.executor_name,
            'dataroot': null,
            'responseAttributes': null,
            'attributeMappings': null,
            'response': null,
        };



        // this.platform.publishEventMessage(this.executor_name, this.selectedVersion,'API TESTING', {
        //     info: 'Checking for testcases <br>Testcases found: 0',
        //     icon: 'fa fa-check-square-o',
        //     type: 'initial'}, timeStamp, action);
        // this.platform.publishEventMessage(this.executor_name, this.selectedVersion,'API TESTING', {
        //     info: 'Checking for testcases <br>Testcases found: 0',
        //     icon: 'fa fa-check-square-o',
        //     type: 'success'}, timeStamp, action);



        if (this.editFlag) {
            if (action === 'redeploy') {
                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DEVELOPMENT', {
                    info: 'Capturing changes made in API definition',
                    type: 'initial',
                    icon: 'fa fa-code'
                }, timeStamp, action);
            }
            if (this.platform.checkEqualStrings(fabResult['executor_display_name'], this.orig_executor['executor_display_name']) &&
                this.platform.checkEqualStrings(fabResult['executor_description'], this.orig_executor['executor_description']) &&
                this.platform.checkEqualStrings(fabResult['executor_category'], this.orig_executor['executor_category']) &&
                this.platform.checkEqualStrings(fabResult['scopeOfAccess'], this.orig_executor['scopeOfAccess']) &&
                this.platform.checkEqualStrings(fabResult['executor_method_type'], this.orig_executor['executor_method_type']) &&
                this.platform.checkEqualStrings(fabResult['dataroot'], this.orig_executor['dataroot']) &&
                this.platform.checkEquality(fabResult['prerequisites'], this.orig_executor['prerequisites']) &&
                this.platform.checkEquality(fabResult['responseAttributes'], this.orig_executor['responseAttributes']) &&
                this.platform.checkEquality(fabResult['response'], this.orig_executor['response']) &&
                this.platform.checkEquality(fabResult['executors'], this.orig_executor['executors']) &&
                this.platform.checkEquality(fabResult['attributeMappings'], this.orig_executor['attributeMappings']) &&
                this.platform.checkEquality(fabResult['pathParams'], this.orig_executor['pathParams']) &&
                this.platform.checkEquality(fabResult['queryParams'], this.orig_executor['queryParams']) &&
                this.platform.checkEquality(fabResult['headers'], this.orig_executor['headers']) &&
                this.platform.checkEquality(fabResult['authModel'], this.orig_executor['authModel']) &&
                this.platform.checkEquality(fabResult['requestBody'], this.orig_executor['requestBody'])) {

                if (action === 'redeploy') {
                    this.loading1 = false;
                    this.closeNonWSDialogBox();
                    // this.displaySnackBarWithWS('Error', 5000, 'No changes to redeploy this Test Suite API.');
                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DEVELOPMENT', {
                        info: 'Capturing changes made in API definition',
                        type: 'fatal',
                        description: 'No changes to redeploy this Test Suite API.',
                        icon: 'fa fa-code'
                    }, timeStamp, action);
                }
                // this.platform.openSnackBar('No changes to redeploy this Test Suite API.', 'Error', {
                //     duration: 10000,
                //     verticalPosition: 'top',
                //     horizontalPosition: 'center'
                // });
            } else {
                if (action === 'redeploy') {
                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DEVELOPMENT', {
                        info: 'Capturing changes made in API definition',
                        type: 'success',
                        icon: 'fa fa-code'
                    }, timeStamp, action);
                }
                fabResult['creationTime'] = this.orig_executor['creationTime'];
                await this.platform.delay(1500);
                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REDEPLOYMENT', {
                    info: 'Updating API Executor',
                    type: 'initial',
                    icon: 'fa fa-cloud-upload'
                }, timeStamp, action);
                this.confPost.updateApiExecutorForPartnerAccount(this.partnerId, this.accountId, this.orig_executor['id'], fabResult).subscribe(async data => {
                    this.platform.updateAPIAuditLog(this.partnerId, this.accountId, fabResult['executor_name'], fabResult['executor_version'], 'TESTSUITE', fabResult, this.orig_executor);
                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REDEPLOYMENT', {
                        info: 'Updating API Executor',
                        type: 'success',
                        icon: 'fa fa-cloud-upload'
                    }, timeStamp, action);
                    Promise.resolve(this.platform.generateActionPayloadForAudit(false, successMessage, 'INFO', data.status, data.statusText, '', fabResult, data, this.router.url)).then(response => {
                        const payloadToSend = {
                            actions: response
                        };
                        this.testSuiteListenerInstance.testSuiteListener.emit({
                            type: 'audit',
                            id: localStorage.getItem('IdOfSession'),
                            payload: payloadToSend
                        });
                    });
                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                        info: 'Updating Gateway Settings for the API',
                        type: 'initial',
                        icon: 'fa fa-shield'
                    }, timeStamp, action);
                    await this.kongService.updateRouteWithMethods(this.partnerId, this.accountId, this.executor_name, this.selectedVersion, [this.selectedExecutor], timeStamp, action);
                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                        info: 'Updating Gateway Settings for the API',
                        type: 'success',
                        icon: 'fa fa-shield'
                    }, timeStamp, action);
                    this.orig_executor = fabResult;
                    this.leftPanelDataListener.changeInLeftPanelDataV2.emit('testsuite');

                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DOCUMENTATION', {
                        info: 'Generating Documentation',
                        type: 'initial',
                        icon: 'fa fa-book'
                    }, timeStamp, action);
                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DOCUMENTATION', {
                        info: 'Generating Documentation',
                        type: 'success',
                        icon: 'fa fa-book'
                    }, timeStamp, action);
                    await this.platform.delay(2000);
                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'DONE', {
                        info: '',
                        type: 'success',
                        icon: 'fa fa-check'
                    }, timeStamp, action);
                    // this.Blocks = [1, 2, 4];
                    // const blockLength = this.Blocks.length;
                    // const blockStart = this.BlockList[this.Blocks[0]];
                    // const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                    // this.progress = blockStart;
                    // if (!this.websocketService.isOpen()) {
                    //     that.setInterval(blockEnd, true);
                    // }
                    this.loading1 = false;
                    this.closeNonWSDialogBox();
                }, error => {
                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REDEPLOYMENT', {
                        info: 'Updating API Executor',
                        type: 'error',
                        icon: 'fa fa-cloud-upload'
                    }, timeStamp, action);
                    Promise.resolve(this.platform.generateActionPayloadForAudit(true, failedMessage, 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), fabResult, error, this.router.url)).then(response => {
                        const payloadToSend = {
                            actions: response
                        };
                        this.testSuiteListenerInstance.testSuiteListener.emit({
                            type: 'audit',
                            id: localStorage.getItem('IdOfSession'),
                            payload: payloadToSend
                        });
                    });
                    // this.displaySnackBarWithWS('Error', 10000, 'Error while redeploying API. Please try again after sometime.');
                    // this.platform.handleErrorGracefully(error, 'Error while redeploying API. Please try again after sometime.');
                    this.loading1 = false;
                    this.closeNonWSDialogBox();
                });



                // this.confPost.deleteApiExecutorByPartnerAccountByNameAndVersion(this.partnerId, this.accountId, this.partnerKey, this.editable_executor_name, this.editable_executor_version).subscribe(response => {
                //     if (response) {
                //         this.confPost.insertApiExecutorForPartnerAccount(this.partnerId, this.accountId, fabResult).subscribe(data => {
                //
                //
                //
                //         }, error => {
                //             this.platform.handleErrorGracefully(error, 'Error while redeploying API. Please try again after sometime.');
                //             this.loading1 = false;
                //         });
                //     }
                // }, error => {
                //     this.platform.handleErrorGracefully(error, 'Error while redeploying API. Please try again after sometime.');
                //     this.loading1 = false;
                // });
            }
        } else {
            // this.platform.publishEventMessage(this.executor_name, this.selectedVersion,'API DEPLOYMENT', {
            //     info: 'Deploying API',
            //     type: 'initial',
            //     icon : 'fa fa-cloud-upload'}, timeStamp, action);
            if (this.headersData) {
                for (let i = 0; i < this.headersData.length; i++) {
                    if (this.headersData[i]) {
                        if (this.headersData[i]['key'] === '') {
                            this.headersData.splice(i, 1);
                        }
                    }
                }
            }
            if (this.headersData.filter(element => element.key === 'pkey').length === 0) {
                this.headersData.push({
                    key: 'pkey',
                    value: '',
                    description: ''
                });
            }
            if (this.headersData.filter(element => element.key === 'apikey').length === 0) {
                this.headersData.push({
                    key: 'apikey',
                    value: '',
                    description: ''
                });
            }
            this.confPost.insertApiExecutorForPartnerAccount(this.partnerId, this.accountId, fabResult).subscribe(async data => {

                // await this.kongService.updateRouteWithMethods(this.partnerId, this.accountId, this.executor_name, this.selectedVersion, [this.selectedExecutor], timeStamp, action);
                await this.kongService.configureApiGatewayWithIpRestrictionWithMethods(this.partnerId, this.accountId, this.executor_name, this.selectedVersion, false, true, [this.selectedExecutor], timeStamp, action);
                // this.platform.publishEventMessage(this.executor_name, this.selectedVersion,'API DEPLOYMENT', {
                //     info: 'Deploying API',
                //     type: 'success'}, timeStamp, action);
                await this.platform.generateAccountRolePermissionGroupAndPermissions(this.partnerId, this.accountId, localStorage.getItem('signInEmail'), this.executor_name, this.selectedVersion, 'TESTSUITE', true, timeStamp, action);

                this.orig_executor = fabResult;
                this.leftPanelDataListener.changeInLeftPanelDataV2.emit('testsuite');
                this.Blocks = [1, 2, 4];
                const blockLength = this.Blocks.length;
                const blockStart = this.BlockList[this.Blocks[0]];
                const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                this.progress = blockStart;
                this.loading1 = false;
                this.closeNonWSDialogBox();
                // if (!this.websocketService.isOpen()) {
                //     // that.setInterval(blockEnd, true);
                //     this.logVisible = true;
                //     this.refreshLogCount++;
                // }

                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DOCUMENTATION', {
                    info: 'Generating Documentation',
                    type: 'initial',
                    icon: 'fa fa-book'
                }, timeStamp, action);
                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DOCUMENTATION', {
                    info: 'Generating Documentation',
                    type: 'success',
                    icon: 'fa fa-book'
                }, timeStamp, action);
                await this.platform.delay(2000);
                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'DONE', {
                    info: '',
                    type: 'success',
                    icon: 'fa fa-check'
                }, timeStamp, action);
            }, error => {
                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DEPLOYMENT', {
                    info: 'Deploying API',
                    type: 'error'
                }, timeStamp, action);
                Promise.resolve(this.platform.generateActionPayloadForAudit(true, failedMessage, 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), fabResult, error, this.router.url)).then(response => {
                    const payloadToSend = {
                        actions: response
                    };
                    this.testSuiteListenerInstance.testSuiteListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                this.loading1 = false;
                this.closeNonWSDialogBox();
                // this.platform.handleErrorGracefully(error, 'Error while deploying Test Suite API. Please try again after sometime');
            });
        }
    }

    updateValuesFromXML() {
        this.platform.createNestedObject(this.externalTestsuiteObj, ['project', 'scm', 'userRemoteConfigs', 'hudson.plugins.git.UserRemoteConfig', 'url'] );
        this.externalTestsuiteConfigs.repositoryUrl = this.externalTestsuiteObj['project']['scm']['userRemoteConfigs']['hudson.plugins.git.UserRemoteConfig']['url']['_text'];

        this.platform.createNestedObject(this.externalTestsuiteObj, ['project', 'scm', 'branches', 'hudson.plugins.git.BranchSpec', 'name'] );
        this.externalTestsuiteConfigs.branchSpecifier = this.externalTestsuiteObj['project']['scm']['branches']['hudson.plugins.git.BranchSpec']['name']['_text'];

        this.platform.createNestedObject(this.externalTestsuiteObj, ['project', 'builders', 'hudson.tasks.Shell', 'command'] );
        this.externalTestsuiteConfigs.executionCommands = this.externalTestsuiteObj['project']['builders']['hudson.tasks.Shell']['command']['_text'];
    }
    
    updateAndGetExternalConfigXml() {
        this.externalTestsuiteConfigs.executionCommands = this.externalTestsuiteConfigs.executionCommands.replace(/\n/g, '; ');

        this.platform.createNestedObject(this.externalTestsuiteObj, ['project', 'scm', 'userRemoteConfigs', 'hudson.plugins.git.UserRemoteConfig', 'url'] );
        this.externalTestsuiteObj['project']['scm']['userRemoteConfigs']['hudson.plugins.git.UserRemoteConfig']['url']['_text'] = this.externalTestsuiteConfigs.repositoryUrl;

        this.platform.createNestedObject(this.externalTestsuiteObj, ['project', 'scm', 'branches', 'hudson.plugins.git.BranchSpec', 'name'] );
        this.externalTestsuiteObj['project']['scm']['branches']['hudson.plugins.git.BranchSpec']['name']['_text'] = this.externalTestsuiteConfigs.branchSpecifier;

        this.platform.createNestedObject(this.externalTestsuiteObj, ['project', 'builders', 'hudson.tasks.Shell', 'command'] );
        this.externalTestsuiteObj['project']['builders']['hudson.tasks.Shell']['command']['_text'] = this.externalTestsuiteConfigs.executionCommands;

        const xmlString = converter.js2xml(this.externalTestsuiteObj, {compact: true, spaces: 2});
        return xmlString;
    }

    async deployExternalTestSuite(timeStamp) {

        const action = this.action;
        if (this.externalTestsuiteConfigs.repositoryUrl && this.externalTestsuiteConfigs.repositoryUrl !== '') {
            if (this.externalTestsuiteConfigs.branchSpecifier && this.externalTestsuiteConfigs.branchSpecifier !== '') {
                if (this.externalTestsuiteConfigs.executionCommands && this.externalTestsuiteConfigs.executionCommands !== '') {
                    if (this.websocketService.isOpen()) {
                        this.logVisible = true;
                    }

                    const successMessage = this.editFlag === true ? 'testsuite_edit_redeploy_success' : 'testsuite_create_deploy_success';
                    const failedMessage = this.editFlag === true ? 'testsuite_edit_redeploy_failed' : 'testsuite_create_deploy_failed';
                    this.loading1 = true;
                    this.gatewayFullUrl = 'https://' + await this.platform.getDefaultGatewayURL();

                    const fabResult = {
                        'executor_type': this.executorType,
                        'executor_name': this.executor_name,
                        'executor_version': this.selectedVersion,
                        'executor_display_name': this.executor_display_name,
                        'executor_description': this.description,
                        'executor_category': this.executorCategory,
                        'published': true,
                        'scopeOfAccess': this.scopeSelected,
                        'creationTime': Date.now(),
                        'lastModifiedTime': Date.now(),
                        'registeredAsIs': false,
                        'executor_method_type': this.selectedExecutor,
                        'queryParams': this.parameterData,
                        'headers': this.headersData,
                        'requestBody': this.requestBody,
                        'prerequisites': this.prerequisites,
                        'executors': [],
                        'partner': this.partnerId,
                        'account_id': this.accountId,
                        'apiUrl': this.gatewayFullUrl + '/' + this.selectedVersion + '/' + this.executor_name,
                        'dataroot': null,
                        'responseAttributes': null,
                        'attributeMappings': null,
                        'response': null,
                    };


                    if (this.editFlag) {
                        if (action === 'redeploy') {
                            this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DEVELOPMENT', {
                                info: 'Capturing changes made in API definition',
                                type: 'initial',
                                icon: 'fa fa-code'
                            }, timeStamp, action);
                        }
                        if (this.platform.checkEqualStrings(fabResult['executor_display_name'], this.orig_executor['executor_display_name']) &&
                            this.platform.checkEqualStrings(fabResult['executor_description'], this.orig_executor['executor_description']) &&
                            this.platform.checkEqualStrings(fabResult['executor_category'], this.orig_executor['executor_category']) &&
                            this.platform.checkEqualStrings(fabResult['scopeOfAccess'], this.orig_executor['scopeOfAccess']) &&
                            this.platform.checkEqualStrings(fabResult['executor_method_type'], this.orig_executor['executor_method_type']) &&
                            this.platform.checkEqualStrings(fabResult['dataroot'], this.orig_executor['dataroot']) &&
                            this.platform.checkEquality(fabResult['prerequisites'], this.orig_executor['prerequisites']) &&
                            this.platform.checkEquality(fabResult['responseAttributes'], this.orig_executor['responseAttributes']) &&
                            this.platform.checkEquality(fabResult['response'], this.orig_executor['response']) &&
                            this.platform.checkEquality(fabResult['executors'], this.orig_executor['executors']) &&
                            this.platform.checkEquality(fabResult['attributeMappings'], this.orig_executor['attributeMappings']) &&
                            this.platform.checkEquality(fabResult['pathParams'], this.orig_executor['pathParams']) &&
                            this.platform.checkEquality(fabResult['queryParams'], this.orig_executor['queryParams']) &&
                            this.platform.checkEquality(fabResult['headers'], this.orig_executor['headers']) &&
                            this.platform.checkEquality(fabResult['authModel'], this.orig_executor['authModel']) &&
                            this.platform.checkEquality(fabResult['source'], this.orig_executor['source']) &&
                            this.platform.checkEquality(fabResult['requestBody'], this.orig_executor['requestBody'])) {

                            if (action === 'redeploy') {
                                this.loading1 = false;
                                this.closeNonWSDialogBox();
                                // this.displaySnackBarWithWS('Error', 5000, 'No changes to redeploy this Test Suite API.');
                                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DEVELOPMENT', {
                                    info: 'Capturing changes made in API definition',
                                    type: 'fatal',
                                    description: 'No changes to redeploy this Test Suite API.',
                                    icon: 'fa fa-code'
                                }, timeStamp, action);
                            }
                            // this.platform.openSnackBar('No changes to redeploy this Test Suite API.', 'Error', {
                            //     duration: 10000,
                            //     verticalPosition: 'top',
                            //     horizontalPosition: 'center'
                            // });
                        } else {
                            if (action === 'redeploy') {
                                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DEVELOPMENT', {
                                    info: 'Capturing changes made in API definition',
                                    type: 'success',
                                    icon: 'fa fa-code'
                                }, timeStamp, action);
                            }
                            await this.platform.delay(500);

                            fabResult['creationTime'] = this.orig_executor['creationTime'];
                            fabResult['apiUrl'] = this.orig_executor['apiUrl'];

                            const xmlString = this.updateAndGetExternalConfigXml();

                            const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
                            const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);

                            await this.platform.encryptAttribute(salt, iv, this.passphrase, xmlString, this.keySize, this.iterationCount).then(response => {
                                fabResult['source'] = response;
                                fabResult['workflow_credentials'] = {};
                                fabResult['workflow_credentials']['shash'] = salt;
                                fabResult['workflow_credentials']['ralam'] = iv;
                            });

                            const jobName = this.partnerId + '-' + this.accountId + '-' + this.executor_name + '-' + this.selectedVersion;

                            this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_DEVELOPMENT, {
                                info: 'Updating job configuration',
                                type: 'initial',
                                icon: 'fa fa-code'
                            }, timeStamp, action);
                            this.confPost.manageJenkinsJob('update', jobName, {source: xmlString}).subscribe(async jobdata => {
                                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_DEVELOPMENT, {
                                    info: 'Updating job configuration',
                                    type: 'success',
                                    icon: 'fa fa-code'
                                }, timeStamp, action);
                                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REDEPLOYMENT', {
                                    info: 'Updating API Executor',
                                    type: 'initial',
                                    icon: 'fa fa-cloud-upload'
                                }, timeStamp, action);
                                this.confPost.updateApiExecutorForPartnerAccount(this.partnerId, this.accountId, this.orig_executor['id'], fabResult).subscribe(async data => {
                                    this.platform.updateAPIAuditLog(this.partnerId, this.accountId, fabResult['executor_name'], fabResult['executor_version'], 'TESTSUITE', fabResult, this.orig_executor);
                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REDEPLOYMENT', {
                                        info: 'Updating API Executor',
                                        type: 'success',
                                        icon: 'fa fa-cloud-upload'
                                    }, timeStamp, action);
                                    Promise.resolve(this.platform.generateActionPayloadForAudit(false, successMessage, 'INFO', data.status, data.statusText, '', fabResult, data, this.router.url)).then(response => {
                                        const payloadToSend = {
                                            actions: response
                                        };
                                        this.testSuiteListenerInstance.testSuiteListener.emit({
                                            type: 'audit',
                                            id: localStorage.getItem('IdOfSession'),
                                            payload: payloadToSend
                                        });
                                    });
                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                                        info: 'Updating Gateway Settings for the API',
                                        type: 'initial',
                                        icon: 'fa fa-shield'
                                    }, timeStamp, action);
                                    await this.kongService.updateRouteWithMethods(this.partnerId, this.accountId, this.executor_name, this.selectedVersion, [this.selectedExecutor], timeStamp, action);
                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                                        info: 'Updating Gateway Settings for the API',
                                        type: 'success',
                                        icon: 'fa fa-shield'
                                    }, timeStamp, action);
                                    this.orig_executor = fabResult;
                                    this.leftPanelDataListener.changeInLeftPanelDataV2.emit('testsuite');

                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DOCUMENTATION', {
                                        info: 'Generating Documentation',
                                        type: 'initial',
                                        icon: 'fa fa-book'
                                    }, timeStamp, action);
                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DOCUMENTATION', {
                                        info: 'Generating Documentation',
                                        type: 'success',
                                        icon: 'fa fa-book'
                                    }, timeStamp, action);
                                    await this.platform.delay(2000);
                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'DONE', {
                                        info: '',
                                        type: 'success',
                                        icon: 'fa fa-check'
                                    }, timeStamp, action);

                                    this.loading1 = false;
                                    this.closeNonWSDialogBox();
                                }, error => {
                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REDEPLOYMENT', {
                                        info: 'Updating API Executor',
                                        type: 'error',
                                        icon: 'fa fa-cloud-upload'
                                    }, timeStamp, action);
                                    this.loading1 = false;
                                    this.closeNonWSDialogBox();
                                });
                            }, error => {
                                this.loading1 = false;
                                this.closeNonWSDialogBox();
                                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_DEVELOPMENT, {
                                    info: 'Updating job configuration',
                                    type: 'fatal',
                                    icon: 'fa fa-code',
                                    description: 'Error while configuring the job. Please validate the input data or contact adminstator.'
                                }, timeStamp, action);
                            });


                            // this.confPost.deleteApiExecutorByPartnerAccountByNameAndVersion(this.partnerId, this.accountId, this.partnerKey, this.editable_executor_name, this.editable_executor_version).subscribe(response => {
                            //     if (response) {
                            //         this.confPost.insertApiExecutorForPartnerAccount(this.partnerId, this.accountId, fabResult).subscribe(data => {
                            //
                            //
                            //
                            //         }, error => {
                            //             this.platform.handleErrorGracefully(error, 'Error while redeploying API. Please try again after sometime.');
                            //             this.loading1 = false;
                            //         });
                            //     }
                            // }, error => {
                            //     this.platform.handleErrorGracefully(error, 'Error while redeploying API. Please try again after sometime.');
                            //     this.loading1 = false;
                            // });
                        }
                    } else {

                        const xmlString = this.updateAndGetExternalConfigXml();
                        const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
                        const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);

                        await this.platform.encryptAttribute(salt, iv, this.passphrase, xmlString, this.keySize, this.iterationCount).then(response => {
                            fabResult['source'] = response;
                            fabResult['workflow_credentials'] = {};
                            fabResult['workflow_credentials']['shash'] = salt;
                            fabResult['workflow_credentials']['ralam'] = iv;
                        });

                        const jobName = this.partnerId + '-' + this.accountId + '-' + this.executor_name + '-' + this.selectedVersion;

                        this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_DEVELOPMENT, {
                            info: 'Setting up job configuration',
                            type: 'initial',
                            icon: 'fa fa-code'
                        }, timeStamp, action);
                        this.confPost.manageJenkinsJob('create', jobName, {source: xmlString}).subscribe(async jobdata => {
                            this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_DEVELOPMENT, {
                                info: 'Setting up job configuration',
                                type: 'success',
                                icon: 'fa fa-code'
                            }, timeStamp, action);
                            this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DEPLOYMENT', {
                                info: 'Setting up API',
                                type: 'initial',
                                icon: 'fa fa-edit'
                            }, timeStamp, action);

                            if (this.headersData) {
                                for (let i = 0; i < this.headersData.length; i++) {
                                    if (this.headersData[i]) {
                                        if (this.headersData[i]['key'] === '') {
                                            this.headersData.splice(i, 1);
                                        }
                                    }
                                }
                            }
                            if (this.headersData.filter(element => element.key === 'pkey').length === 0) {
                                this.headersData.push({
                                    key: 'pkey',
                                    value: '',
                                    description: ''
                                });
                            }
                            if (this.headersData.filter(element => element.key === 'apikey').length === 0) {
                                this.headersData.push({
                                    key: 'apikey',
                                    value: '',
                                    description: ''
                                });
                            }
                            this.confPost.insertApiExecutorForPartnerAccount(this.partnerId, this.accountId, fabResult).subscribe(async data => {

                                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DEPLOYMENT', {
                                    info: 'Setting up API',
                                    type: 'success',
                                    icon: 'fa fa-edit'
                                }, timeStamp, action);
                                const servicePayload = {
                                    applyCustom: true,
                                    retries: 5,
                                    protocol: 'https',
                                    host: environment.apihostname,
                                    port: 443,
                                    path: '/' + this.partnerId + '/' + this.accountId + '/v1/job/' + this.partnerId + '-' + this.accountId + '-' + this.executor_name + '-' + this.selectedVersion + '/trigger',
                                    connect_timeout: 60000,
                                    write_timeout: 60000,
                                    read_timeout: 60000
                                };

                                await this.kongService.configureApiGatewayWithIpRestrictionWithMethods(this.partnerId, this.accountId, this.executor_name, this.selectedVersion, false, true, [this.selectedExecutor], timeStamp, action, servicePayload);

                                // await this.platform.configureGateway(this.partnerId, this.accountId, this.executor_name, this.selectedVersion, 'https', environment.apihostname, '/' + this.partnerId + '/' + this.accountId + '/v1/job/' + this.partnerId + '-' + this.accountId + '-' + this.executor_name + '-' + this.selectedVersion + '/trigger', 443, ['POST'], false);

                                await this.platform.generateAccountRolePermissionGroupAndPermissions(this.partnerId, this.accountId, localStorage.getItem('signInEmail'), this.executor_name, this.selectedVersion, 'TESTSUITE', true, timeStamp, action);

                                this.orig_executor = fabResult;
                                this.leftPanelDataListener.changeInLeftPanelDataV2.emit('testsuite');
                                this.Blocks = [1, 2, 4];
                                const blockLength = this.Blocks.length;
                                const blockStart = this.BlockList[this.Blocks[0]];
                                const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                                this.progress = blockStart;
                                this.loading1 = false;
                                this.closeNonWSDialogBox();


                                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DOCUMENTATION', {
                                    info: 'Generating Documentation',
                                    type: 'initial',
                                    icon: 'fa fa-book'
                                }, timeStamp, action);
                                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DOCUMENTATION', {
                                    info: 'Generating Documentation',
                                    type: 'success',
                                    icon: 'fa fa-book'
                                }, timeStamp, action);
                                await this.platform.delay(2000);
                                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'DONE', {
                                    info: '',
                                    type: 'success',
                                    icon: 'fa fa-check'
                                }, timeStamp, action);
                            }, error => {
                                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DEPLOYMENT', {
                                    info: 'Setting up API',
                                    type: 'fatal',
                                    icon: 'fa fa-edit',
                                    description: 'Error while setting up the API. Please again later.'
                                }, timeStamp, action);
                                this.loading1 = false;
                                this.closeNonWSDialogBox();
                            });
                        }, error => {
                            this.loading1 = false;
                            this.closeNonWSDialogBox();
                            this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_DEVELOPMENT, {
                                info: 'Setting up job configuration',
                                type: 'fatal',
                                icon: 'fa fa-code',
                                description: 'Error while configuring the job. Please validate the input data or contact adminstator.'
                            }, timeStamp, action);
                        });
                    }
                } else {
                    this.loading1 = false;
                    this.closeNonWSDialogBox();
                    // this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_DEVELOPMENT, {
                    //     info: 'Checking for required fields',
                    //     type: 'fatal',
                    //     icon: 'fa fa-code',
                    //     description: 'Execution commands not found. Please provide valid commands to execute the given code.'
                    // }, timeStamp, action);
                    this.platform.openSnackBar('Execution commands not found. Please provide valid commands to execute the given code.', 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            } else {
                this.loading1 = false;
                this.closeNonWSDialogBox();
                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_DEVELOPMENT, {
                    info: 'Checking for required fields',
                    type: 'fatal',
                    icon: 'fa fa-code',
                    description: 'Branch specifier not found. Please specify the branch name.'
                }, timeStamp, action);
                this.platform.openSnackBar('Branch specifier not found. Please specify the branch name.', 'Error', {
                    duration: 10000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        } else {
            this.loading1 = false;
            this.closeNonWSDialogBox();
            // this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_DEVELOPMENT, {
            //     info: 'Checking for required fields',
            //     type: 'fatal',
            //     icon: 'fa fa-code',
            //     description: 'Repository URL not found. Please provide a valid repository URL.'
            // }, timeStamp, action);

            this.platform.openSnackBar('Repository URL not found. Please provide a valid repository URL.', 'Error', {
                duration: 10000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }

    }


    getRequestBodyValue(val) {
        switch (val) {
            case 'raw':
                // return JSON.stringify(this.editor.get());
                return this.editor.get();
            case 'binary':
            case 'none':
            default:
        }
    }

    getRequestBody() {
        if (this.requestBodySelected === 'raw') {
            const requestbody = {
                'value': this.getRequestBodyValue(this.requestBodySelected),
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'form-data') {
            const requestbody = {
                'value': this.formData,
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'x-www-form-urlencoded') {
            const requestbody = {
                'value': this.formData,
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'none') {
            const requestbody = null;
            return requestbody;
        }
    }


    async runTestSuite() {

        const baseExeModel = {
            //'executor_name': this.executor_name,
            'executor_type': 'API',
            'executor_version': this.selectedVersion,
            'executor_method_type': this.httpOperation,
            'apiUrl': this.httpUrl,
            'dataroot': null,
            'queryParams': this.parameterData,
            'pathParams': this.pathParameter,
            'headers': this.headersData,
            'requestBody': await this.headerChild.getRequestBody(),
            //'executors': this.executors,
            'prerequisites': null
        };

        this.testSuitePayload['name'] = this.executor_name;
        this.testSuitePayload['description'] = '';
        this.testSuitePayload['baseExecutorModel'] = baseExeModel;
        this.testSuitePayload['preSteps'] = this.prestepsPayload;
        this.testSuitePayload['tearDownSteps'] = this.teardownPayload;
        this.testSuitePayload['testCases'] = this.testCasesPayload;
        if (this.testSuitePayload['scopeOfAccess']) {
            delete this.testSuitePayload['scopeOfAccess'];
        }

        const payload = {
            'executor_name': this.executor_name,
            'executor_type': 'TESTSUITE',
            'executor_version': 'v1',
            'executor_method_type': 'POST',
            'apiUrl': 'https://services.apiplatform.io/v1/' + this.partnerId + '/' + this.accountId + '/test-suite',
            'queryParams': this.parameterData,
            'pathParams': this.pathParameter,
            'headers': [{'pkey': localStorage.getItem('partnerKey')}],
            //'authModel': this.authModel1.authModel,
            'requestBody': {},
            'executors': [this.testSuitePayload],
        };

        this.testLoading = true;
        this._service.executeApiV2(payload).subscribe(res => {
            this.testLoading = false;
            if (res) {
                this.testSuiteResponse = JSON.parse(res.body['body']);

                if (this.testSuiteResponse['testCaseResults'] !== undefined) {
                    const dialogRef = this.dialog.open(TestReportComponent, {
                        height: '80%',
                        width: '80%',
                        data: {
                            testSuitePayload: this.testSuitePayload,
                            testSuiteResponse: this.testSuiteResponse
                        }
                    });
                } else {
                    this.platform.openSnackBar('Error while testing the API. Please try again after sometime.', 'Error', {
                        duration: 15000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            }

        }, error => {
            this.testLoading = false;
            this.platform.handleErrorGracefully(error, 'Error while testing the API. Please try again after sometime.');

        });

        let url = 'https://services.apiplatform.io/v1/' + this.partnerId + '/' + this.accountId + '/test-suite/execute';
        // this.httpClient.post('https://services.apiplatform.io/v1/' + this.partnerId + '/' + this.accountId + '/testsuite/execute', {
        //     name: 'testSuite1',
        //     description: '',
        //     baseExecutorModel: {},
        //     preSteps: this.prestepsPayload,
        //     tearDownSteps: this.teardownPayload,
        //     testCases: this.testCasesPayload
        // }, {
        //     headers: {pkey: "3fef2657d98325773fe04c95a4aab4be"}
        // }).subscribe(result => {
        //     this.testSuiteResponse = result;
        //     const dialogRef = this.dialog.open(ReportComponent, {
        //         height: '80%',
        //         width: '80%',
        //         data: {
        //             testSuitePayload: this.testSuitePayload,
        //             testSuiteResponse: this.testSuiteResponse
        //         }
        //     });
        //
        // })
    }

    async saveAPI() {

        const clickMessage = this.editFlag === true ? 'testsuite_edit_save_clicked' : 'testsuite_create_save_clicked';
        const successMessage = this.editFlag === true ? 'testsuite_edit_save_success' : 'testsuite_create_save_success';
        const failedMessage = this.editFlag === true ? 'testsuite_edit_save_failed' : 'testsuite_create_save_failed';

        Promise.resolve(this.platform.generateActionPayloadForAudit(false, clickMessage, 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response1 => {
            const payloadToSend = {
                actions: response1
            };
            this.testSuiteListenerInstance.testSuiteListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });

        const savePayload = {
            partner: '',
            account: '',
            executor_name: '',
            executor_type: '',
            by: '',
            executor_version: '',
            action: ''
        };

        savePayload.partner = this.partnerId;
        savePayload.account = this.accountId;
        savePayload['at'] = Date.now();
        savePayload.by = this.partnerId;
        savePayload.executor_name = this.executor_name ? this.executor_name : Date.now().toString();
        savePayload.executor_version = this.selectedVersion;
        savePayload.executor_type = this.selectedExecutor;
        if (this.editFlag) {
            savePayload.action = 'UPDATE';
        } else {
            savePayload.action = 'CREATE';
        }

        savePayload.executor_type = 'TESTSUITE';

        const baseExeModel = {
            //'executor_name': this.executor_name,
            'executor_type': 'API',
            'executor_version': this.selectedVersion,
            'executor_method_type': this.httpOperation,
            'apiUrl': this.httpUrl,
            'dataroot': null,
            'queryParams': this.parameterData,
            'pathParams': this.pathParameter,
            'headers': this.headersData,
            'requestBody': await this.headerChild.getRequestBody(),
            //'executors': this.executors,
            'prerequisites': null
        };

        this.testSuitePayload['name'] = this.executor_name;
        this.testSuitePayload['description'] = this.description;
        this.testSuitePayload['executor_display_name'] = this.executor_display_name;
        this.testSuitePayload['executor_method_type'] = this.selectedExecutor;
        this.testSuitePayload['scopeOfAccess'] = this.scopeSelected;
        this.testSuitePayload['executor_category'] = this.executorCategory;
        this.testSuitePayload['baseExecutorModel'] = baseExeModel;
        this.testSuitePayload['preSteps'] = this.prestepsPayload;
        this.testSuitePayload['tearDownSteps'] = this.teardownPayload;
        this.testSuitePayload['testCases'] = this.testCasesPayload;

        savePayload['executor'] = this.testSuitePayload;

        const temp = JSON.parse(JSON.stringify(savePayload['executor']));
        let isSame = true;
        if (this.previousSavedData !== undefined && this.previousSavedData !== null) {
            if (Object.keys(this.previousSavedData).length === Object.keys(temp).length) {
                const keyArray = Object.keys(this.previousSavedData);
                for (const key of keyArray) {
                    if (JSON.stringify(this.previousSavedData[key]) === JSON.stringify(temp[key])) {
                        continue;
                    } else {
                        isSame = false;
                        break;
                    }
                }
            } else {
                isSame = false;
            }
        } else {
            isSame = false;
        }

        if (isSame === false) {
            this.confPost.saveExecutorInformation('v1', savePayload).subscribe(data => {
                Promise.resolve(this.platform.generateActionPayloadForAudit(false, successMessage, 'INFO', data.status, data.statusText, '', savePayload, data, this.router.url)).then(response => {
                    const payloadToSend = {
                        actions: response
                    };
                    const log_payload = {
                        logType: 'INFO',
                        logLevel: 0,
                        slugSearch: '',
                        label: 'API_SAVE',
                        featureArea: this.platform.auditFeatureArea.plsql,
                        resource: 'API_SAVE',
                        action: 'SAVE',
                        result: 'SUCCESS',
                        payload: savePayload,
                        responseStatusCode: data.status,
                        response: data,
                        errorMessage: '',
                        logMessage: 'API saved'
                    };
                    this.auditLog.log(log_payload);
                    this.testSuiteListenerInstance.testSuiteListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                this.previousSavedData = JSON.parse(JSON.stringify(savePayload['executor']));
                this.platform.openSnackBar('API has been saved successfully.', 'Success', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.leftPanelDataListener.saveEntityAndExecutors.emit('success');
            }, error => {
                Promise.resolve(this.platform.generateActionPayloadForAudit(true, failedMessage, 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), savePayload, error, this.router.url)).then(response => {
                    const payloadToSend = {
                        actions: response
                    };
                    const log_payload = {
                        logType: 'ERROR',
                        logLevel: 0,
                        slugSearch: '',
                        label: 'API_SAVE',
                        featureArea: this.platform.auditFeatureArea.plsql,
                        resource: 'API_SAVE',
                        action: 'SAVE',
                        result: 'FAIL',
                        payload: savePayload,
                        responseStatusCode: error.status,
                        response: error,
                        errorMessage: this.platform.returnErrorMessage(error),
                        logMessage: 'Error in saving API'
                    };
                    this.auditLog.log(log_payload);
                    this.testSuiteListenerInstance.testSuiteListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                this.platform.handleErrorGracefully(error, 'Error while saving the API. Please try again after sometime.');
            });
        } else {
            this.platform.openSnackBar('No changes to save for this TestSuite', 'Error', {
                duration: 10000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }

    }

    setInterval(blockEnd, nextPanel) {
        this.destroy = setInterval(() => this.manageProgress(blockEnd, nextPanel), 1000);
    }

    ngOnDestroy() {
        clearInterval(this.destroy);
    }

    displayFn(user?: ICategory): string | undefined {
        return user ? user.name : undefined;
    }

    manageProgress(target, showPanel) {
        if (this.progress <= target) {
            // this.showNextPanel = showPanel;
            // this.cfgSrv.getPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
            //     let item = data;
            // this.kongService.getKeyAuthForConsumerInApiGatewayByNameOrId(item['primary_email']).subscribe(keys => {
            this.save = false;
            let apiKey = localStorage.getItem('apikey');
            const dialogRef = this.dialog.open(DialogComponent, {
                maxWidth: '95vw',
                data: {
                    type: 'bl',
                    save: true,
                    gatewayFullUrl: this.gatewayFullUrl,
                    Blocks: this.Blocks,
                    selectedVersion: this.selectedVersion,
                    showNextPanel: false,
                    partner: this.partnerId,
                    account: this.accountId,
                    selectedExecutor: this.selectedExecutor,
                    executor_name: this.executor_name,
                    apiKey: apiKey,
                    partnerKey: this.partnerKey
                }
            });
            dialogRef.afterClosed().subscribe(async result => {
                if (result === 'create') {
                    await this.router.navigateByUrl('/testsuite');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else if (result === 'edit') {
                    //this.router.navigateByUrl('/businesslogic/edit?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.executor_name + '&version=' + this.selectedVersion);
                } else if (result === 'execute') {
                    //this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account_id + '&executor_name=' + this.executor_name + '&executor_version=' + this.selectedVersion);
                } else if (result === 'devex') {
                    //this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account_id + '&executor_name=' + this.executor_name + '&executor_version=' + this.selectedVersion + '&showDoc=true');
                }
            });
            // });
            // });
            this.ngOnDestroy();
        } else {
            this.progress = this.progress + incr;
        }
        if (this.progress <= 35) {
            this.progressMessage = 'Setting Up Business Logic API';
        } else if (this.progress > 35 && this.progress <= 70) {
            this.progressMessage = 'Setting Up Database';
        } else if (this.progress > 70) {
            this.progressMessage = 'Deploying into Cloud';
        }
    }

    createMarginRight() {
        document.getElementById('view:test-suite').style.marginRight = '400px';
    }

    removeMarginRight() {
        document.getElementById('view:test-suite').style.marginRight = '0px';
    }
}


@Component({
    templateUrl: 'confirm-testcase-deletion.html'
})
export class ConfirmTestcaseDeletionComponent {
    constructor(
        public dialogRef: MatDialogRef<ConfirmTestcaseDeletionComponent>,
        @Inject(MAT_DIALOG_DATA) public data: TestcaseDeleteData) {
    }

}


// @Component({
//     templateUrl: './report/report.component.html'
// })
//
// export class TestSuiteReportDialog {
//     constructor(
//         public dialogRef: MatDialogRef<TestSuiteReportDialog>,
//         @Inject(MAT_DIALOG_DATA) public data: TestSuiteData) {
//     }
//
// }
